import { onCtxAbort, reaction } from '@reatom/framework'

import { blockHashAtom } from '@root/entities/blockhash/atoms'
import { Network, selectedNetworkAtom } from '@root/entities/network'
import { blockHashEvent } from '@root/entities/realtime'
import { dependenciesAtom } from '@root/features/shared/dependencies'

export const initializeBlockhashAction = reaction((ctx) => {
  const network = ctx.spy(selectedNetworkAtom)

  if (network !== Network.Solana) {
    return
  }

  const { chartWebsocket } = ctx.get(dependenciesAtom)
  blockHashEvent.onCall((ctx, blockHash) => {
    blockHashAtom(ctx, blockHash)
  })

  chartWebsocket.subscribeBlockhashAction(ctx, undefined)
  onCtxAbort(ctx, () => {
    chartWebsocket.unsubscribeBlockhashAction(ctx, undefined)
  })
}, 'initializeBlockhashAction')
